export default __webpack_public_path__ + "static/media/react_native.7bd9f6d5.png";